import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

function UpcomingSessionItem({ session, isLast }) {
  const startDate = new Date(session.startDate);
  const endDate = new Date(session.endDate);

  const isSameDay = (
    (startDate.getDate() === endDate.getDate()) &&
    (startDate.getMonth() === endDate.getMonth()) &&
    (startDate.getFullYear() === endDate.getFullYear())
  );
  const isSameMonth = (
    (startDate.getMonth() === endDate.getMonth()) &&
    (startDate.getFullYear() === endDate.getFullYear())
  );

  const scheduleDay = isSameDay ? startDate.getDate() : (`${startDate.getDate()} - ${endDate.getDate()}`);
  const scheduleMonth = isSameMonth ?
    startDate.toLocaleString('default', { month: 'short' }) :
    (`${startDate.toLocaleString('default', { month: 'short' })}-${endDate.toLocaleString('default', { month: 'short' })}`);
  const scheduleTime = moment(startDate).format('hh:mm A');

  return (
    <div data-testid="upcomingSessionDetails" className={`row py-2 ${!isLast ? 'upcoming-session-item-border' : ''}`}>
      <div className="col-3 col-lg-2 text-center vertical-center">
        <div className="row">
          <div className="col-12 pb-0">
            <h3
              data-testid="scheduledDay"
              className={`upcoming-session-item-day ${isSameDay ? 'single' : 'double'}`}
            >
              {scheduleDay}
            </h3>
            <h4
              data-testid="scheduledMonth"
              className={`upcoming-session-item-month ${isSameMonth ? 'single' : 'double'}`}
            >
              {scheduleMonth}
            </h4>
          </div>
          <div className="col-12">
            <span data-testid="scheduledTime" className="upcoming-session-item-description">{scheduleTime}</span>
          </div>
        </div>
      </div>
      <div className="col-9 col-lg-10 py-2">
        <div className="row">
          <div className="col-12">
            <h5>
              <a
                data-testid="upcomingSessionLink"
                href={`/academy/sessions/${session.slug}`}
                className="upcoming-session-item-title"
              >
                {session.title}
              </a>
            </h5>
          </div>
          <div className="col-12">
            <span className="upcoming-session-item-description">{session?.summary || ''}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

UpcomingSessionItem.propTypes = {
  session: PropTypes.shape({
    slug: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    title: PropTypes.string,
    summary: PropTypes.string,
  }).isRequired,
  isLast: PropTypes.bool,
};

UpcomingSessionItem.defaultProps = {
  isLast: false,
};

export default (UpcomingSessionItem);
